import styled from 'styled-components';

export const SectionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;
